import React from 'react';
import { Constent } from '../../Assets/Constants/Constent';
import { CloseModalIcon, ConfirmationIcon } from '../../Assets/Images/CelcomSvgImages';

const NextPageConfirmationModal = ({ message, btnName1, btnName2, btnRoute1, btnRoute2, submitBtnConfirmation }) => {
    return (
        <div className="modal fade next-page-confirmation-modal" id="requestStockPlaceOrderModal" data-backdrop="static"
            data-keyboard="false" tabIndex="-1" aria-labelledby="requestStockPlaceOrderModalLabel"
            aria-modal="true" role="dialog">
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header pb-0">
                        <div className="wrapper-modal-header pt-5">
                            <div className="modal-header-title-section">
                                <ConfirmationIcon />
                                <h5 className="modal-title" id="requestStockPlaceOrderModalLabel">
                                    {Constent.CONFIRMATION_MODAL_TITLE}
                                </h5>
                                <h5 className="modal-title">
                                    {message}
                                </h5>
                            </div>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">
                                    <CloseModalIcon />
                                </span>
                            </button>
                        </div>
                    </div>
                    <div className="modal-body">
                        <div className="wrapper-modal-body">

                        </div>
                    </div>
                    <div className="modal-footer">
                        <div className="refresh-btn-section" data-dismiss="modal">
                            <span>{btnName1}</span>
                        </div>
                        <div className="search-btn-section" data-dismiss="modal" onClick={submitBtnConfirmation}>
                            {btnName2}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NextPageConfirmationModal;